<app-leveltwo [pageName]="'Mills Act'">
    <div heading="General Info" class="General">
      <h3>{{'MillsAct.SearchTitle'|translate}}</h3>

      <h4>{{'MillsAct.TaxIncentives'|translate}}</h4>

      <p [innerHTML]="'MillsAct.SearchDescription'|translate"></p>
      <p [innerHTML]="'MillsAct.MillsActContracts'|translate"></p>

      <h4>{{'MillsAct.HowDoesthe'|translate}}</h4>
      <p [innerHTML]="'MillsAct.AfteraPropertyOwner'|translate"></p>
      <p [innerHTML]="'MillsAct.TheRestricted'|translate"></p>

      <p [innerHTML]="'MillsAct.Formore'|translate"></p>
      <h4>{{'MillsAct.HowcanI'|translate}}</h4>
      <p [innerHTML]="'MillsAct.EachCity'|translate"></p>

    </div>

</app-leveltwo>
